export var AtaPricingModel;
(function (AtaPricingModel) {
    AtaPricingModel["Lopande"] = "L\u00F6pande";
    AtaPricingModel["Fast"] = "Fast";
})(AtaPricingModel || (AtaPricingModel = {}));
export var AtaStatusType;
(function (AtaStatusType) {
    AtaStatusType["InProgress"] = "inprogress";
    AtaStatusType["Done"] = "done";
    AtaStatusType["OnReferral"] = "onreferral";
    AtaStatusType["Rejected"] = "rejected";
    AtaStatusType["UnderDevelopment"] = "underdevelopment";
    AtaStatusType["InvoicingOk"] = "invoicingok";
    AtaStatusType["Approved"] = "approved";
})(AtaStatusType || (AtaStatusType = {}));
export var AtaType;
(function (AtaType) {
    AtaType["B"] = "B";
    AtaType["HG"] = "HG";
    AtaType["Other"] = "Annan";
})(AtaType || (AtaType = {}));
/**
 * Statuses a GUEST user is allowed to *change* an ÄTA to. Guests may approve,
 * reject or put an ÄTA on referral, but not drive it further through the system.
 */
export const GUEST_EDITABLE_ATA_STATUSES = [
    AtaStatusType.OnReferral,
    AtaStatusType.Approved,
    AtaStatusType.Rejected,
];
/**
 * Statuses a GUEST user is allowed to *create* an ÄTA with. A guest can only
 * create an ÄTA under development; CESG reviews it before it progresses.
 */
export const GUEST_CREATABLE_ATA_STATUSES = [AtaStatusType.UnderDevelopment];
